import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/technicalIntervention/reschedule`;

interface ReScheduleTechnicalInterventionCommandPayload {
  fileId: string;
}

async function reScheduleTechnicalInterventionCommand({
  fileId,
}: ReScheduleTechnicalInterventionCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const response = await apiCall(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        fileId,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default reScheduleTechnicalInterventionCommand;
